import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListAreas } from "../../../components/Admin/Areas";
import { useLanguage } from "../../../contexts";
import "./Areas.scss";

export function Areas() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_areas"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListAreas areasActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_areas"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListAreas areasActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="areas-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="areas-page-header-wrapper">
        <div className="areas-page-header">
          <span className="areas-page-title">{translations.areas}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
